<template>
  <v-page-content class="d-flex flex-column align-items-center newsList mx-auto">
    <h3><em class="fas fa-1x fa-newspaper"></em> Лента новостей</h3>
    <div class="d-flex flex-wrap justify-content-between mb-2 align-items-center">
      <h4 class="mb-0">Актуальные мероприятия</h4>
      <div class="ml-auto">
        <router-link to="events" append>
          <b-button variant="outline-primary">
            Показать все
          </b-button>
        </router-link>
      </div>
    </div>
    <template v-if="lastEvents && lastEvents.length">
      <b-carousel
        :interval="4000"
        controls
        indicators
        background="#e4dede"
      >
        <b-carousel-slide
          v-for="event in lastEvents"
          :key="event.id"
          class="events-carousel-container"
        >
          <template #img>
            <div class="d-flex text-center h-100">
              <img
                :src="event.avatar ? getContentPath(event) : defaultImage"
                :class="isImageHorizontal(event
                  .avatar ? getContentPath(event) : defaultImage) ? 'w-100' : 'h-100'"
                class="my-auto mx-auto"
                @error="$event.target.src = defaultImage"
              />
            </div>
          </template>
          <div class="div-event-title">
            <strong>
              {{ new Date(event.scheduleDate).toLocaleDateString() }}.
            </strong>
              <router-link :to="'events/' + event.id" append v-if="event.title">
                  {{
                  event.title.length > getLengthByWidth
                    ? event.title.slice(0, getLengthByWidth) + '...'
                    : event.title
                }}
              </router-link>
          </div>
        </b-carousel-slide>
      </b-carousel>
    </template>
    <template v-else>
      <div class="events-carousel-container overflow-hidden">
        <skeleton-event
          :count="1"
        />
      </div>
    </template>
    <div class="newsList mx-auto mt-4">
      <div class="d-flex flex-wrap justify-content-between mb-2 align-items-center">
        <h3 class="mb-0">Актуальные новости</h3>
        <div class="ml-auto">
          <router-link to="news" append>
            <b-button variant="outline-primary">
              Показать все
            </b-button>
          </router-link>
        </div>
      </div>
      <template v-if="lastNews && lastNews.length">
        <div class="row newsList" v-for="news in lastNews" :key="news.id">
          <div class="col-12 col-lg-3">
            <router-link :to="'news/' + news.id" append>
              <b-img
                class="w-100 mb-2"
                @error="$event.target.src = defaultImage"
                :src="news.avatar ? getContentPath(news) : defaultImage"
                fluid
              />
            </router-link>
          </div>
          <div class="col-12 col-lg-9 newsContent">
            <div>
              <h4>
                {{ new Date(news.createdAt).toLocaleDateString() }}.
                <span v-html="news.title"></span>
              </h4>
            </div>
            <div
              v-show="news.shortDescription !== emptyText"
              v-html="news.shortDescription"
              class="text-justify"
            ></div>
            <br /><br />
            <div class="newsLink">
              <router-link :to="'news/' + news.id" append
                >Перейти к новости</router-link
              >
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <skeleton-news :count="5" />
      </template>
    </div>
  </v-page-content>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { emptyShortDescription } from '@/config/config'
import { statusFilters } from '@/config/content/statuses'
import SkeletonEvent from '@/components/ui/skeleton/SkeletonEvent.vue'
import SkeletonNews from '@/components/ui/skeleton/SkeletonNews.vue'

export default {
  name: 'NewsFeed',
  components: {
    SkeletonNews,
    SkeletonEvent
  },
  data() {
    return {
      carouselStyle: {
        height: '350px',
        width: '100%',
        'max-width': '2000px'
      },
      emptyText: emptyShortDescription,
      contentCountOnPage: 5,
      defaultImage: '/images/w1400_1.jpg',
      windowWidth: 0
    }
  },
  mounted() {
    this.windowWidth = window.innerWidth

    this.fetchEvents({
      pages: {
        perPage: this.contentCountOnPage,
        pageNumber: 1,
        filters: [{ param: 'status', needle: [statusFilters.accepted] }]
      },
      withoutClassEvents: true
    })
    this.fetchNews({
      perPage: this.contentCountOnPage,
      pageNumber: 1,
      filters: [{ param: 'status', needle: [statusFilters.accepted] }]
    })
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    this.setEvents([])
    this.setNews([])
  },
  computed: {
    ...mapGetters({
      lastEvents: 'content/getEvents',
      lastNews: 'content/getNews'
    }),
    getLengthByWidth() {
      if (this.windowWidth < 400) {
        return 40
      } else if (this.windowWidth < 600) {
        return 80
      } else {
        return 200
      }
    }
  },
  methods: {
    ...mapActions({
      fetchEvents: 'content/fetchEvents',
      fetchNews: 'content/fetchNews'
    }),
    ...mapMutations({
      setEvents: 'content/setEvents',
      setNews: 'content/setNews'
    }),
    onResize() {
      this.windowWidth = window.innerWidth
    },
    isImageHorizontal(photo) {
      const img = new Image()
      img.src = photo
      return img.naturalWidth > img.naturalHeight
    },
    getContentPath(event) {
      const file = event.files.find((p) => p.id === event.avatar)
      return file ? `/api/files/${file.physicalName}` : this.defaultImage
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../sass/vendor/bootstrap/variables";

.div-event-title {
  text-align: justify;
  word-wrap: break-word;
  background-color: #ffffffe8;
  font-size: 18px;
  color: $primary-color;
  padding: 10px 20px;
}

.row {
  margin-bottom: 25px;
}

.newsContent {
  position: relative;
}

.newsList {
  max-width: 800px;
}

.newsLink {
  bottom: 0px;
  position: absolute;
}
.events-carousel-container {
  height: 380px;
}

@media screen and (max-width: 540px) {
  .events-carousel-container {
    height: 240px;
  }
}
</style>
